<template>
  <div class='localeChange_box' ref="localeChangeBox">
    <div
    v-for="item in localeList"
    class="localeChange_item"
    :class="{'localeChange_item-active': curLocale === item.value}"
    @click="changeLocale(item.value)"
    :key="item.value"
  >{{ item.name }}</div>
  </div>
</template>
<script>
import {setLang, getLang} from '../mx-service/libs/locale'
import device from '@/mx-service/libs/utils/device'
export default {
  name: 'localeChange',
  data(){
    return{
      localeList: [{
        value: 'zh-CN',
        name: '中文'
      },{
        value: 'en-US',
        name: 'English'
      },{
        value: 'ja-JP',
        name: '日本語'
      }],
      curLocale: 'zh-CN',
    }
  },
  methods: {
    changeLocale(e){
      setLang(e)
      localStorage.setItem('locale', e)
      this.curLocale = e
      this.closeBox()
    },
    closeBox(){
      this.$emit('closeBox');
    }
  },
  mounted(){
    this.curLocale = getLang()
    this.$nextTick(() => {
      const target = this.$refs.localeChangeBox;
      console.log(123)
      if(device.isMobile()) return
      document.addEventListener('mousedown', (event) => {
        if (!target.contains(event.target)) {
          this.closeBox()
        }
      });
    });
  }
}
</script>
<style lang='less'>
.localeChange_box {
  width: 145px;
  background: #fff;
  position: absolute;
  top: 40px;
  left: -50px;
  border-radius: 8px;

  .localeChange_item {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

    &-active {
      color: #04A0EE;
    }
  }
}
</style>
